import { useState } from 'react';

export default function BuyTogetherBuyBox(props: any) {
	const [loading, setLoading] = useState(false);
	const {
		subtitle,
		buttonText,
		showButtonIcon,
		showListPrice,
		showSellingPrice,
		showInstallments,
		showTotalPrice,
		showNumberOfItems,
		handles,
	} = props;

	const handeClick = () => {
		setLoading(true);
		setTimeout(() => {
			setLoading(false);
		}, 2000);
	};

	return (
		<div
			className={`${handles.buyTogetherBuyCard} ba b--muted-4 br3 bg-white pv6 ph5 ma2 flex flex-column w-100 w-auto-l mt9 mt2-l`}
		>
			{(showListPrice || showSellingPrice) && (
				<div className={`${handles.buyTogetherBuyCardPrice} flex items-center justify-center t-small tc pb4 w-100`}>
					{showListPrice && (
						<span className={`${handles.buyTogetherBuyCardListPrice} strike pr3`}>
							{/* format text */}

							<span className="maeztraio-buy-together-1-x-currencyContainer">
								<span className="maeztraio-buy-together-1-x-currencyCode">R$</span>
								<span className="maeztraio-buy-together-1-x-currencyLiteral">&nbsp;</span>
								<span className="maeztraio-buy-together-1-x-currencyInteger">360</span>
								<span className="maeztraio-buy-together-1-x-currencyDecimal">,</span>
								<span className="maeztraio-buy-together-1-x-currencyFraction">00</span>
							</span>
							{/* format text */}
						</span>
					)}

					{showSellingPrice && (
						<span className={`${handles.buyTogetherBuyCardSellingPrice} c-action-primary`}>
							{/* format text */}
							<span className="maeztraio-buy-together-1-x-currencyContainer">
								<span className="maeztraio-buy-together-1-x-currencyCode">R$</span>
								<span className="maeztraio-buy-together-1-x-currencyLiteral">&nbsp;</span>
								<span className="maeztraio-buy-together-1-x-currencyInteger">360</span>
								<span className="maeztraio-buy-together-1-x-currencyDecimal">,</span>
								<span className="maeztraio-buy-together-1-x-currencyFraction">00</span>
							</span>
							{/* format text */}
						</span>
					)}
				</div>
			)}

			{showInstallments && (
				<div className={`${handles.buyTogetherBuyCardInstallment} t-heading-6 c-action-primary tc pb4 w-100`}>
					<span className={`${handles.buyTogetherBuyCardSavePriceCount} b`}>10x</span> de{' '}
					<span className={`${handles.buyTogetherBuyCardSavePriceValue} b`}>
						{/* format text */}
						<span className="maeztraio-buy-together-1-x-currencyContainer">
							<span className="maeztraio-buy-together-1-x-currencyCode">R$</span>
							<span className="maeztraio-buy-together-1-x-currencyLiteral">&nbsp;</span>
							<span className="maeztraio-buy-together-1-x-currencyInteger">36</span>
							<span className="maeztraio-buy-together-1-x-currencyDecimal">,</span>
							<span className="maeztraio-buy-together-1-x-currencyFraction">00</span>
						</span>
						{/* format text */}
					</span>
				</div>
			)}

			{
				showTotalPrice ? (
					<div className={`${handles.buyTogetherBuyCardSubtitle} t-small tc pb6 w-100`}>
						<>
							{subtitle && subtitle?.length > 0 ? (
								subtitle
							) : (
								<span className="maeztraio-buy-together-1-x-currencyContainer">
									{/* format text */}
									<span className="maeztraio-buy-together-1-x-currencyCode">R$</span>
									<span className="maeztraio-buy-together-1-x-currencyLiteral">&nbsp;</span>
									<span className="maeztraio-buy-together-1-x-currencyInteger">36</span>
									<span className="maeztraio-buy-together-1-x-currencyDecimal">,</span>
									<span className="maeztraio-buy-together-1-x-currencyFraction">00</span>
									{/* format text */}
								</span>

								//  <FormattedMessage id="store/buy-collection.subtitle" />
							)}{' '}
							<span className={`${handles.buyTogetherBuyCardSubtitleSellingPrice} t-heading-6 c-action-primary b`}>
								<span className="maeztraio-buy-together-1-x-currencyContainer">
									{/* format text */}
									<span className="maeztraio-buy-together-1-x-currencyCode">R$</span>
									<span className="maeztraio-buy-together-1-x-currencyLiteral">&nbsp;</span>
									<span className="maeztraio-buy-together-1-x-currencyInteger">36</span>
									<span className="maeztraio-buy-together-1-x-currencyDecimal">,</span>
									<span className="maeztraio-buy-together-1-x-currencyFraction">00</span>
									{/* format text */}
								</span>
							</span>
						</>
					</div>
				) : null
				//  (
				// <div className={`${handles.buyTogetherBuyCardSubtitle} t-small tc pb6 w-100`} >
				//     {discount && (
				//     <>
				//         {subtitle && subtitle?.length > 0 ? (
				//         subtitle
				//         ) : (
				//         <span className="maeztraio-buy-together-1-x-currencyContainer">
				//             {/* format text */}
				//             <span className="maeztraio-buy-together-1-x-currencyCode">R$</span>
				//             <span className="maeztraio-buy-together-1-x-currencyLiteral">&nbsp;</span>
				//             <span className="maeztraio-buy-together-1-x-currencyInteger">10</span>
				//             <span className="maeztraio-buy-together-1-x-currencyDecimal">,</span>
				//             <span className="maeztraio-buy-together-1-x-currencyFraction">00</span>
				//             {/* format text */}
				//         </span>
				//         )}{' '}
				//         <span className={`${handles.buyTogetherBuyCardSubtitleSavePrice} c-action-primary b`} >
				//         <span className="maeztraio-buy-together-1-x-currencyContainer">
				//             {/* format text */}
				//             <span className="maeztraio-buy-together-1-x-currencyCode">R$</span>
				//             <span className="maeztraio-buy-together-1-x-currencyLiteral">&nbsp;</span>
				//             <span className="maeztraio-buy-together-1-x-currencyInteger">10</span>
				//             <span className="maeztraio-buy-together-1-x-currencyDecimal">,</span>
				//             <span className="maeztraio-buy-together-1-x-currencyFraction">00</span>
				//             {/* format text */}
				//         </span>
				//         </span>
				//     </>
				//     )}

				//     </div>
				// )
			}

			<button
				onClick={handeClick}
				className={`  ${handles.buyTogetherBuyCardButton}
                    ${loading ? handles.buyTogetherBuyCardButtonLoading : ''}
                    w-100 h-100 flex items-center justify-center pointer bg-action-primary b--action-primary c-on-action-primary hover-bg-action-primary hover-b--action-primary hover-c-on-action-primary pointer `}
				disabled={loading}
			>
				{loading ? (
					<svg
						className="vtex-styleguide-9-x-rotate vtex__icon-spinner   "
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 100 100"
						preserveAspectRatio="xMidYMid"
						height="24"
						width="24"
					>
						<circle
							className="vtex-spinner_circle"
							cx="50"
							cy="50"
							fill="none"
							r="40"
							stroke="white"
							stroke-width="10"
							stroke-dasharray="0 0 163.36281798666926 251.32741228718345"
							stroke-linecap="round"
							stroke-dashoffset="1"
						></circle>
					</svg>
				) : (
					<>
						{showButtonIcon && (
							<span className={`${handles.buyTogetherBuyCardButtonIcon} flex pr5`}>
								<svg
									className="maeztraio-buy-together-1-x-cartIcon"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M6 2L3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V6L18 2H6Z"
										stroke="white"
										stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round"
									></path>
									<path
										d="M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10"
										stroke="white"
										stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round"
									></path>
									<path
										d="M3 6H21"
										stroke="white"
										stroke-width="1.5"
										stroke-linecap="round"
										stroke-linejoin="round"
									></path>
								</svg>
							</span>
						)}

						<span className={`${handles.buyTogetherBuyCardButtonText} flex`}>
							{buttonText && buttonText?.length > 0 ? (
								buttonText
							) : (
								<div>{'<FormattedMessage id="store/buy-collection.button-text" />'}</div>
							)}
						</span>

						{showNumberOfItems && <span className={`${handles.buyTogetherBuyCardButtonNumber} flex pl2`}>(10)</span>}
					</>
				)}
			</button>
		</div>
	);
}
